import { useEffect } from 'react';

const SEO = ({ title, description, path, schema }) => {
  useEffect(() => {
    // 1. Nastavení titulku stránky
    document.title = title;

    // 2. Pomocná funkce pro správu meta a link tagů
    const setTag = (selector, attrName, attrValue, contentAttr, contentValue) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        const type = selector.startsWith('link') ? 'link' : 'meta';
        el = document.createElement(type);
        if (attrName) el.setAttribute(attrName, attrValue);
        document.head.appendChild(el);
      }
      el.setAttribute(contentAttr, contentValue);
    };

    const baseUrl = "https://www.lightwell.cz";
    const fullUrl = `${baseUrl}${path === '/' ? '' : path}`;

    // Standardní Meta Tagy
    setTag('meta[name="description"]', 'name', 'description', 'content', description);
    setTag('link[rel="canonical"]', 'rel', 'canonical', 'href', fullUrl);

    // Open Graph Tagy (pro Facebook/LinkedIn)
    setTag('meta[property="og:title"]', 'property', 'og:title', 'content', title);
    setTag('meta[property="og:description"]', 'property', 'og:description', 'content', description);
    setTag('meta[property="og:url"]', 'property', 'og:url', 'content', fullUrl);
    setTag('meta[property="og:type"]', 'property', 'og:type', 'content', 'website');

    // Twitter Card Tagy
    setTag('meta[name="twitter:title"]', 'name', 'twitter:title', 'content', title);
    setTag('meta[name="twitter:description"]', 'name', 'twitter:description', 'content', description);

    // 3. Správa JSON-LD strukturovaných dat
    let script = document.head.querySelector('script[type="application/ld+json"]');
    if (schema) {
      if (!script) {
        script = document.createElement('script');
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schema);
    } else if (script) {
      // Pokud stránka nemá schéma, odstraníme to z předchozí stránky
      script.remove();
    }

    // Volitelný úklid při odchodu ze stránky není nutný, 
    // protože další stránka si tagy opět přepíše svými hodnotami.
  }, [title, description, path, schema]);

  return null; // Komponenta nic nerenderuje do UI
};

export default SEO;